export default __webpack_public_path__ + "static/media/resolucao-13-19-cfoab.623c501d.pdf";